import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=1be80850&scoped=true&"
import script from "./calendar.vue?vue&type=script&lang=js&"
export * from "./calendar.vue?vue&type=script&lang=js&"
import style0 from "./calendar.vue?vue&type=style&index=0&id=1be80850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be80850",
  null
  
)

export default component.exports